module.exports = __webpack_public_path__ + "img/couponIcon.5ed48fa2.svg";